"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var core_1 = require("@formily/core");
var useDirty_1 = require("./useDirty");
var react_eva_1 = require("react-eva");
var context_1 = require("../context");
var shared_1 = require("../shared");
var shared_2 = require("@formily/shared");
var useForceUpdate_1 = require("./useForceUpdate");
var FormHookSymbol = Symbol('FORM_HOOK');
var DEV_TOOLS_HOOK = '__FORMILY_DEV_TOOLS_HOOK__';
var formID = 0;
var useInternalForm = function (options) {
    if (options === void 0) { options = {}; }
    var forceUpdate = useForceUpdate_1.useForceUpdate();
    var ref = react_1.useRef({
        subscribeId: null
    });
    var dirty = useDirty_1.useDirty(options, ['initialValues', 'values', 'editable']);
    var alreadyHaveForm = !!options.form;
    var alreadyHaveHookForm = options.form && options.form[FormHookSymbol];
    var form = react_1.useMemo(function () {
        var form = alreadyHaveForm ? options.form : core_1.createForm(options);
        if (!alreadyHaveForm) {
            ref.current.subscribeId = form.subscribe(function (_a) {
                var type = _a.type;
                if (type === core_1.LifeCycleTypes.ON_FORM_HOST_RENDER) {
                    forceUpdate();
                }
            });
        }
        return form;
    }, []);
    react_1.useEffect(function () {
        if (alreadyHaveHookForm)
            return;
        if (dirty.num > 0) {
            form.setFormState(function (state) {
                if (dirty.dirtys.values && shared_2.isValid(options.values)) {
                    state.values = options.values;
                }
                if (dirty.dirtys.initialValues && shared_2.isValid(options.initialValues)) {
                    state.initialValues = options.initialValues;
                }
                if (dirty.dirtys.editable && shared_2.isValid(options.editable)) {
                    state.editable = options.editable;
                }
            });
        }
    });
    react_1.useEffect(function () {
        if (alreadyHaveHookForm)
            return;
        form.setFormState(function (state) {
            state.mounted = true;
        });
        formID++;
        if (shared_2.globalThisPolyfill[DEV_TOOLS_HOOK]) {
            shared_2.globalThisPolyfill[DEV_TOOLS_HOOK].inject(formID, form);
        }
        return function () {
            form.unsubscribe(ref.current.subscribeId);
            form.setFormState(function (state) {
                state.unmounted = true;
            });
            if (shared_2.globalThisPolyfill[DEV_TOOLS_HOOK]) {
                shared_2.globalThisPolyfill[DEV_TOOLS_HOOK].unmount(formID);
            }
        };
    }, []);
    form[FormHookSymbol] = true;
    return form;
};
exports.useForm = function (props) {
    var actionsRef = react_1.useRef(null);
    actionsRef.current =
        actionsRef.current || props.actions || shared_1.createFormActions();
    var broadcast = react_1.useContext(context_1.BroadcastContext);
    var _a = react_eva_1.useEva({
        actions: actionsRef.current,
        effects: shared_1.createFormEffects(props.effects, actionsRef.current)
    }), implementActions = _a.implementActions, dispatch = _a.dispatch;
    var lifecycles = [
        new core_1.FormLifeCycle(function (_a) {
            var type = _a.type, payload = _a.payload;
            dispatch.lazy(type, function () {
                var _a;
                return (payload === null || payload === void 0 ? void 0 : payload.getState) ? (_a = payload.getState) === null || _a === void 0 ? void 0 : _a.call(payload) : payload;
            });
            if (broadcast) {
                broadcast.notify({ type: type, payload: payload });
            }
        }),
        new core_1.FormLifeCycle(core_1.LifeCycleTypes.ON_FORM_WILL_INIT, function (form, formApi) {
            var actions = __assign(__assign({}, formApi), { dispatch: formApi.notify });
            implementActions(actions);
            if (broadcast) {
                broadcast.setContext(actions);
            }
        })
    ];
    var optionsRef = react_1.useRef(__assign(__assign({}, props), { initialValues: props.initialValues || props.defaultValue }));
    Object.assign(optionsRef.current, props);
    optionsRef.current.values = props.value;
    optionsRef.current.lifecycles = lifecycles;
    var form = useInternalForm(optionsRef.current);
    return form;
};
exports.default = exports.useForm;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@formily/react/lib/hooks/useForm.js
// module id = 2070
// module chunks = 0